// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".compare-detail[data-v-691a3c0b]{min-height:407px}.compare-detail .tit[data-v-691a3c0b]{text-align:center;font-size:20px;font-weight:bold;margin:20px 0}.compare-detail .total-tips[data-v-691a3c0b]{text-align:center;margin-top:20px;color:#f56c6c;font-size:18px}.compare-detail .content-box .content-tit[data-v-691a3c0b]{padding:10px 0}.compare-detail .table-full-row[data-v-691a3c0b]{width:100% !important}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
